export { IToolsConfig, toolsConfig } from './tools-config';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/tools/models/index.ts